import { Box, Typography, Divider } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { signin, transfer } from "../../keychain/login";
import { cambiarPass } from "../../services/cambiarPass";
import { Stake } from "./profile/Stake";
import { getCookie } from "../../utils/getCookies";
import { rutas } from "../../rutas/rutas";
import axios from "axios";
import { setInformacion } from "../../store/slices/usuarios";
import Referido from "./profile/Referido";
import CambioCf from "./profile/CambioCf";

export const Profile = ({ handleClose }) => {
  const { informacion } = useSelector((state) => state.userSlice);
  const dispatch = useDispatch();

  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");

  // ✅ KOD -> VIPHUESO
  const [token, settoken] = useState("VIPHUESO");

  const [cantidad, setCantidad] = useState("");
  const [open, setOpen] = useState(false);
  const [open3, setOpen3] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose2 = () => setOpen(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => setOpen3(false);

  const hiveUser = informacion?.nombre || "";
  const email = informacion?.correo || "";

  const balances = useMemo(() => {
    return {
      hive: Number(informacion?.hive || 0),
      viphueso: Number(informacion?.viphueso || 0),
      hueso: Number(informacion?.hueso || 0),
      cf: Number(informacion?.cf || 0),
      // si todavía existe en algunos usuarios viejos:
      kod: Number(informacion?.kod || 0),
    };
  }, [informacion]);

  const handlePass = async () => {
    try {
      if (pass?.length <= 3 || pass?.length > 24) return;
      await cambiarPass();
      alert("succes");
    } catch (error) {
      alert("error");
    }
  };

  const refreshUsuario = async () => {
    const tokenAUTH = getCookie("token");
    if (!tokenAUTH) return;

    try {
      const { data } = await axios.get(`${rutas.getUsuario}`, {
        headers: { token: tokenAUTH },
      });
      dispatch(setInformacion(data));
    } catch (_) {}
  };

  const handleDeposit = () => {
    const qty = parseFloat(cantidad);
    if (qty > 0 && !hiveUser?.includes("@null")) {
      transfer(qty, `Deposit ${token}`, token, hiveUser);
    }
  };

  const handleRetiro = async () => {
    try {
      const tokenAUTH = getCookie("token");

      const qty = Number(cantidad);
      if (!Number.isFinite(qty) || qty <= 0) {
        alert("Invalid quantity");
        return;
      }

      await axios({
        url: rutas.retiroReal,
        data: { token, cantidad: qty }, // ✅ ahora mandas cantidad
        method: "post",
        headers: { token: tokenAUTH },
      });

      const { data } = await axios.get(`${rutas.getUsuario}`, {
        headers: { token: tokenAUTH },
      });

      dispatch(setInformacion(data));
      alert("SUCCESS");
    } catch (error) {
      alert(error?.response?.data?.error || "ERROR");
    }
  };

  const handleAsociar = async () => {
    if (hiveUser?.includes("@null")) {
      signin(user, () => {}, null, true);
    }
  };

  // estilos suaves sin romper rpgui
  const cardSX = {
    p: 2,
    borderRadius: 2,
    background: "rgba(0,0,0,0.10)",
  };

  const labelSX = { fontSize: 12, opacity: 0.85 };
  const valueSX = { fontSize: 14, fontWeight: 700 };

  return (
    <>
      <Grid2
        sx={{ width: "100%", height: "100%", overflow: "auto", position: "relative" }}
        className="rpgui-container"
        container
        spacing={2}
      >
        {/* LEFT */}
        <Grid2 className="rpgui-container framed-golden" xs={12} md={7} sx={{ position: "relative" }}>
          <Box
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 10,
              top: 8,
              zIndex: 10000000000001,
              color: "gray",
              cursor: "pointer",
              fontWeight: 900,
            }}
          >
            X
          </Box>

          <Box sx={{ display: "grid", gap: 0.5 }}>
            <Typography sx={{ fontWeight: 900, fontSize: 18 }}>Profile</Typography>
            <Typography sx={{ fontSize: 13 }}>
              <b>User HIVE:</b> {hiveUser}
            </Typography>
            <Typography sx={{ fontSize: 13 }}>
              <b>Email:</b> {email}
            </Typography>
          </Box>

          <Divider sx={{ my: 1.2, opacity: 0.25 }} />

          {hiveUser?.includes("@") && (
            <input onChange={(e) => setUser(e.target.value)} placeholder="User" />
          )}
          <input onChange={(e) => setPass(e.target.value)} placeholder="Password" />

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
            <button onClick={handleOpen3} className="rpgui-button">
              <p>convert CF</p>
            </button>

            <button onClick={handleOpen} className="rpgui-button">
              <p>referrals</p>
            </button>

            <button onClick={handlePass} className="rpgui-button">
              <p>Password</p>
            </button>

            {hiveUser?.includes("@") && (
              <button onClick={handleAsociar} className="rpgui-button">
                <p>associate a HIVE</p>
              </button>
            )}
          </Box>

          <Divider sx={{ my: 1.2, opacity: 0.25 }} />

          <Box sx={{ ...cardSX }}>
            <Typography sx={{ fontWeight: 900, mb: 0.5 }}>Quick stats</Typography>
            <Box sx={{ display: "grid", gap: 0.5 }}>
              <Typography sx={{ fontSize: 13 }}>
                Open tickets: <b>{informacion?.tiketAbiertos || 0}</b>
              </Typography>
              <Typography sx={{ fontSize: 13 }}>
                Hive token earned: <b>{informacion?.hiveGanado || 0}</b>
              </Typography>
            </Box>
          </Box>
        </Grid2>

        {/* RIGHT */}
        <Grid2 className="rpgui-container framed-golden" xs={12} md={5}>
          <Typography sx={{ fontWeight: 900, fontSize: 16, mb: 1 }}>Wallet</Typography>

          <Box sx={{ display: "grid", gap: 1 }}>
            <Box sx={{ ...cardSX }}>
              <Box sx={{ display: "grid", gap: 0.6 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography sx={labelSX}>HIVE</Typography>
                  <Typography sx={valueSX}>{balances.hive}</Typography>
                </Box>

                {/* ✅ VIPHUESO destacado */}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography sx={{ ...labelSX, color: "gold" }}>VIPHUESO</Typography>
                  <Typography sx={{ ...valueSX, color: "gold" }}>{balances.viphueso}</Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography sx={labelSX}>HUESO</Typography>
                  <Typography sx={valueSX}>{balances.hueso}</Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography sx={labelSX}>CF</Typography>
                  <Typography sx={valueSX}>{balances.cf}</Typography>
                </Box>

                {/* (opcional) si quieres ver si queda algo viejo */}
                {balances.kod > 0 && (
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={{ ...labelSX, color: "orange" }}>KOD (legacy)</Typography>
                    <Typography sx={{ ...valueSX, color: "orange" }}>{balances.kod}</Typography>
                  </Box>
                )}
              </Box>
            </Box>

            <Box sx={{ ...cardSX }}>
              <Typography sx={{ fontWeight: 900, mb: 0.5 }}>Deposit / Withdraw</Typography>

              <input
                value={cantidad}
                onChange={(e) => setCantidad(e.target.value)}
                placeholder="Quantity"
              />

              <select
                value={token}
                typeof="number"
                onChange={(e) => settoken(e.target.value)}
                style={{ width: "100%", marginTop: 6 }}
                class="rpgui-dropdown"
              >
                {/* ✅ KOD -> VIPHUESO */}
                <option value="VIPHUESO">VIPHUESO</option>
                <option value="HUESO">HUESO</option>
                <option value="SWAP.HIVE">SWAP.HIVE</option>
              </select>

              <Box sx={{ display: "flex", gap: 1, mt: 1, flexWrap: "wrap" }}>
                <button onClick={handleDeposit} className="rpgui-button">
                  <p>deposit</p>
                </button>
                <button onClick={handleRetiro} className="rpgui-button">
                  <p>withdraw</p>
                </button>
                <button onClick={refreshUsuario} className="rpgui-button">
                  <p>refresh</p>
                </button>
              </Box>
            </Box>
          </Box>
        </Grid2>

        {/* STAKE (hidden) */}
        {/* 
        <Grid2
          sx={{ height: "100%", overflow: "auto", width: "100%" }}
          className="rpgui-container framed-golden"
          xs={12}
        >
          <Stake />
        </Grid2>
        */}
      </Grid2>

      <Referido open={open} handleClose={handleClose2} />
      <CambioCf open={open3} handleClose={handleClose3} />
    </>
  );
};
